<template>
  <div class='h-toolbarBg'>
    <ejs-toolbar>
      <e-items>
        <e-item v-if='false' prefixIcon='icon hero-icon hero-icon-export' :tooltipText='$ts("Track.import")' :click='buttonClk' operate='import'></e-item>
        <e-item v-if='isImport' prefixIcon='icon hero-icon hero-icon-import' :tooltipText='$ts("Track.export")' :click='buttonClk' operate='export'></e-item>
        <e-item v-if='!isImport' prefixIcon='icon hero-icon hero-icon-start-up' :tooltipText='$ts("Track.activation")' :click='buttonClk' operate='active'></e-item>
        <e-item v-if='!isImport' prefixIcon='icon hero-icon hero-icon-disable' :tooltipText='$ts("Track.hangup")' :click='buttonClk' operate='hangup'></e-item>
        <e-item v-if='!isImport' prefixIcon='icon hero-icon hero-icon-confirm' :tooltipText='$ts("Track.finish")' :click='buttonClk' operate='finish'></e-item>
        <e-item prefixIcon='icon hero-icon hero-icon-filter' :tooltipText='$ts("Track.search")' :click='buttonClk' operate='search'></e-item>
      </e-items>
    </ejs-toolbar>
  </div>
</template>
<script>
import i18n from '../../../plugins/i18n.js';

export default {
  name: 'ImportTableMenu',
  data() {
    return {};
  },
  props: {
    isImport: { type: Boolean, default: false },
  },
  methods: {
    $ts(args) {
      const mes = args.split('.');
      const result = (mes[0] && mes[1] && i18n.messages[i18n.locale][mes[0]][mes[1]]) ? i18n.messages[i18n.locale][mes[0]][mes[1]] : args;
      return result;
    },
    buttonClk(args) {
      this.$emit('methodEnum', args.item.operate);
    }
  }
};
</script>
